/* AfterShed quiz v3: one question per screen, branching per situation, answer-based interstitials and a result
   page that hands its context to the product page through sessionStorage (never through the URL).
   Content: snippets/r3-quiz-content.liquid. Spec and question table: ressaine-v3/QUIZ-SPEC-V3.md.
   Data (12-10-2026, Thomas): every quiz is saved without name/email/IP on our own server (VPS
   /aftershed-quiz/p, keyed by a random quiz id) so we can see which answers lead to orders. The quiz id rides
   along as the hidden cart attribute _quiz_id; the server links and tags the order later. Email only with the
   consent box on the result -> Klaviyo (routine emails per answer). Answers never go to Meta or other advertisers.
   Shopify analytics events stay without answers: r3_quiz_started {} and r3_quiz_completed {questions}. */
(function () {
  'use strict';

  var root = document.querySelector('[data-r3-quiz]');
  if (!root) return;
  var contentEl = document.querySelector('[data-r3-quiz-content]');
  var dataEl = root.querySelector('[data-r3-quiz-data]');
  if (!contentEl || !dataEl) return;
  var C, D;
  try { C = JSON.parse(contentEl.textContent); D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  // Once subscriptions are live, the subscription wording replaces the one-time-only lines.
  if (D.hasPlans && C.when_subscription) {
    (function merge(t, s) { Object.keys(s).forEach(function (k) { if (s[k] && typeof s[k] === 'object' && !Array.isArray(s[k]) && t[k]) merge(t[k], s[k]); else t[k] = s[k]; }); })(C, C.when_subscription);
  }

  var Q = C.questions;
  var SITS = ['menopause', 'postpartum', 'weight', 'stress', 'pill', 'unsure'];
  var BRANCH = {
    menopause: ['meno_stage', 'meno_hrt'],
    postpartum: ['pp_months'],
    weight: ['wt_stage', 'wt_eating'],
    stress: ['stress_when'],
    pill: ['pill_change', 'pill_months'],
    unsure: ['unsure_changes', 'unsure_family']
  };
  var STORE = 'r3_quiz';
  var API = 'https://srv1528121.hstgr.cloud/aftershed-quiz';
  var TTL = 2 * 60 * 60 * 1000;
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PICK_MS = RM ? 60 : 170;      // how long a picked answer stays visible before moving on
  var SWAP_MS = RM ? 0 : 320;       // screen transition
  var GUARD_MS = 160;               // ignore taps right after a new screen appears
  var LOADING_MS = RM ? 400 : 3100; // 13-10 (Thomas): the loading step takes 2 s longer, with a status line
  var READY_STEP_MS = RM ? 120 : 1050; // one progress bar on "Getting your system ready"

  var stage = root.querySelector('[data-r3q-stage]');
  var live = root.querySelector('[data-r3q-live]');
  var backBtn = root.querySelector('[data-r3q-back]');
  var bar = root.querySelector('[data-r3q-bar]');
  var barFill = root.querySelector('[data-r3q-fill]');
  var chapterEl = root.querySelector('[data-r3q-chapter]');
  var exitLink = root.querySelector('[data-r3q-exit]');

  var state = { answers: {}, trail: [], preset: null, edit: false, startedSent: false, qid: null };
  var busy = false;
  var guardUntil = 0;

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function has(arr, v) { return Array.isArray(arr) && arr.indexOf(v) !== -1; }
  function opt(qid, v) {
    var q = Q[qid];
    if (qid === 'situation') {
      var s = C.situations[v];
      return s ? { v: v, l: s.l, d: s.d, s: s.s } : null;
    }
    if (!q || !q.options) return null;
    for (var i = 0; i < q.options.length; i++) if (q.options[i].v === v) return q.options[i];
    return null;
  }
  function optionsFor(qid) {
    if (qid === 'situation') {
      return SITS.map(function (k) { var s = C.situations[k]; return { v: k, l: s.l, d: s.d, s: s.s, img: (D.thumbs || {})[k] || (D.images || {})[k] }; });
    }
    return Q[qid].options;
  }
  function publish(name, payload) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload || {}); } catch (e) {}
  }
  function newId() {
    var a = new Uint8Array(12);
    try { crypto.getRandomValues(a); } catch (e) { for (var i = 0; i < a.length; i++) a[i] = Math.floor(Math.random() * 256); }
    return 'q' + Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
  }
  function labelsFor(a) {
    var out = {};
    Object.keys(a).forEach(function (qid) {
      var v = a[qid];
      var one = function (x) { var o = opt(qid, x); return o ? o.l : x; };
      out[qid] = Array.isArray(v) ? v.map(one).join('; ') : one(v);
    });
    return out;
  }
  function env() {
    try { if (sessionStorage.getItem('as_quiz_env') === 'test') return 'test'; } catch (e) {}
    if ((window.Shopify && Shopify.designMode) || /preview_theme_id/.test(location.search)) return 'preview';
    return 'live';
  }
  function track() {
    try { var t = JSON.parse(sessionStorage.getItem('r3_track') || 'null'); return t && t.p ? t.p : {}; } catch (e) { return {}; }
  }
  function sync(completed) {
    if (!state.qid || !answered('situation') && !state.preset) return;
    var r = completed ? rec(state.answers) : null;
    var ctx = window.R3 && R3.ctx ? R3.ctx.get() : {};
    var payload = {
      quiz_id: state.qid, env: env(), completed: !!completed, screen: state.trail[state.trail.length - 1] || '',
      answers: state.answers, labels: labelsFor(state.answers), track: track(),
      entry: state.preset ? 'preset:' + (ctx.src || 'site') : 'quiz', landing: location.pathname,
      result: r ? { months: r.mode === 'buy' ? r.months : null, mode: r.mode, state: r.state, careful: r.careful, watch: r.watch, flags: r.flags, pregnant: r.pregnant, minor: r.minor } : {}
    };
    try {
      // text/plain keeps this a simple request (no CORS preflight); keepalive lets it finish on page exit
      return fetch(API + '/p', { method: 'POST', body: JSON.stringify(payload), keepalive: true, mode: 'cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    } catch (e) {}
  }
  function tagCart() {
    try {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _quiz_id: state.qid } }) }).catch(function () {});
    } catch (e) {}
  }
  function announce(text) {
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 40);
  }

  /* ---------- storage ---------- */
  function save() {
    try {
      sessionStorage.setItem(STORE, JSON.stringify({ v: 3, at: Date.now(), answers: state.answers, trail: state.trail, preset: state.preset, qid: state.qid }));
    } catch (e) {}
  }
  function load() {
    try {
      var s = JSON.parse(sessionStorage.getItem(STORE) || 'null');
      if (!s || s.v !== 3 || !s.at || Date.now() - s.at > TTL || !Array.isArray(s.trail) || !s.trail.length) return null;
      return s;
    } catch (e) { return null; }
  }
  function clearStore() { try { sessionStorage.removeItem(STORE); } catch (e) {} }

  /* ---------- routing ---------- */
  function route(a) {
    var r = [];
    if (!state.preset) r.push('situation');
    if (a.situation) r = r.concat(BRANCH[a.situation] || []);
    r.push('shed');
    if (a.shed !== 'none') r.push('notice');
    r.push('tried');
    if (!(Array.isArray(a.tried) && a.tried.length === 1 && a.tried[0] === 'nothing')) r.push('tried_hard');
    r.push('time');
    /* 13-10: the safety question (pregnant, trying, breastfeeding, under 18) is gone at Thomas' request. The result code
       still reads a.safety, so a quiz saved before this change ends the same way. */
    return r;
  }
  function lastSituationQ(r) {
    var last = null;
    r.forEach(function (id) { if (Q[id] && Q[id].chapter === 'situation') last = id; });
    return last;
  }
  function screens(a) {
    var r = route(a);
    var lastSit = lastSituationQ(r);
    var s = [];
    r.forEach(function (id) {
      s.push(id);
      if (id === lastSit && a[id] !== undefined && interA(a)) s.push('i:A');
      if (id === 'time' && a.time && interB(a)) s.push('i:B');
    });
    s.push('result');
    return s;
  }
  function prune() {
    var r = route(state.answers);
    Object.keys(state.answers).forEach(function (k) {
      if (k !== 'situation' && r.indexOf(k) === -1) delete state.answers[k];
    });
  }
  function answered(qid) {
    var v = state.answers[qid];
    return Array.isArray(v) ? v.length > 0 : v !== undefined && v !== null && v !== '';
  }

  /* ---------- interstitials ---------- */
  function flags(a) { return (a.notice || []).filter(function (v) { return v === 'patches' || v === 'scalp'; }); }
  function heavyNow(a) { return a.shed === 'new' || a.shed === 'heavy' || a.shed === 'long'; }
  function interA(a) {
    if (flags(a).length) return 'redflag';
    if (a.shed === 'none') return 'none';
    switch (a.situation) {
      case 'menopause': return a.meno_hrt === 'new' ? 'menopause_hrt' : (a.meno_hrt ? 'menopause' : null);
      case 'postpartum':
        if (a.pp_months === 'gt12' && heavyNow(a)) return 'postpartum_late';
        if (a.pp_months === '2to4' || a.pp_months === '4to6') return 'postpartum_window';
        return a.pp_months ? 'postpartum' : null;
      case 'weight':
        if (a.wt_eating === 'low' || a.wt_eating === 'struggle') return 'weight_eating';
        if (a.wt_stage === 'dose') return 'weight_dose';
        return a.wt_stage ? 'weight' : null;
      case 'stress':
        if (a.stress_when === 'ongoing') return 'stress_ongoing';
        if (a.stress_when === '2to4') return 'stress_lag';
        return a.stress_when ? 'stress' : null;
      case 'pill':
        if ((a.pill_months === '6to12' || a.pill_months === 'gt12') && heavyNow(a)) return 'pill_late';
        return a.pill_months ? 'pill' : null;
      case 'unsure':
        if (!a.unsure_changes) return null;
        return has(a.unsure_changes, 'none') ? 'unsure_none' : 'unsure_some';
    }
    return null;
  }
  function interB(a) {
    var tried = (a.tried || []).filter(function (v) { return v !== 'nothing'; });
    if (a.time === 'short') return 'short';
    if (a.tried_hard === 'nochange') return 'nochange';
    if (a.tried_hard === 'stick') return 'stick';
    if (a.tried_hard === 'irritation') return 'irritation';
    if (a.tried_hard === 'unclear' || tried.length >= 2) return 'clearer';
    if (a.tried_hard === 'cost') return 'cost';
    return null;
  }
  function interCopy(key) {
    var c = C.inter[key];
    if (!c) return null;
    var t = c.t;
    if (key === 'unsure_some') {
      var names = (state.answers.unsure_changes || []).map(function (v) { var o = opt('unsure_changes', v); return o ? o.s : v; });
      var list = names.length > 1 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names[0];
      t = t.replace('{list}', list);
    }
    return { t: t, b: c.b };
  }

  /* ---------- progress ---------- */
  function updateProgress(id) {
    var r = route(state.answers);
    var total = r.length;
    var pos;
    if (id === 'result' || id === 'loading' || id === 'profile' || id === 'plan' || id === 'ready') pos = total;
    else if (id.indexOf('i:') === 0) {
      var t = state.trail;
      var prevQ = null;
      for (var i = t.length - 1; i >= 0; i--) if (Q[t[i]]) { prevQ = t[i]; break; }
      pos = prevQ ? r.indexOf(prevQ) + 1 : 0;
    } else pos = Math.max(0, r.indexOf(id));
    var pct = total ? Math.round((pos / total) * 100) : 0;
    if (barFill) barFill.style.transform = 'scaleX(' + Math.max(0.03, pct / 100) + ')';
    if (bar) {
      bar.setAttribute('aria-valuenow', String(pct));
      bar.setAttribute('aria-valuetext', id === 'result' ? 'Your result' : (Q[id] ? 'Question ' + (pos + 1) + ' of ' + total : pct + '%'));
    }
    var chapter = id === 'result' || id === 'loading' || id === 'profile' || id === 'plan' || id === 'ready' ? 'next' : (Q[id] ? Q[id].chapter : (id === 'i:A' ? 'situation' : 'routine'));
    var idx = 0;
    C.chapters.forEach(function (ch, i) { if (ch.id === chapter) idx = i; });
    if (chapterEl) {
      chapterEl.innerHTML = C.chapters.map(function (ch, i) {
        return '<span class="r3q-ch' + (i < idx ? ' is-done' : '') + (i === idx ? ' is-current' : '') + '"' + (i === idx ? ' aria-current="step"' : '') + '>' + esc(ch.label) + '</span>';
      }).join('');
    }
    if (backBtn) backBtn.hidden = state.trail.length <= 1 && id !== 'result';
  }

  /* ---------- screen builders ---------- */
  function chapterLabel(chId) {
    var n = 1, label = '';
    C.chapters.forEach(function (ch, i) { if (ch.id === chId) { n = i + 1; label = ch.label; } });
    return '<p class="r3q-kicker"><span class="r3-num">0' + n + '</span><span class="r3-label">' + esc(label) + '</span></p>';
  }

  function buildQuestion(qid) {
    var q = Q[qid];
    var multi = q.type === 'multi';
    var cur = state.answers[qid];
    var el = document.createElement('div');
    el.className = 'r3q-screen r3q-screen--question' + (q.visual ? ' r3q-screen--visual' : '');
    el.setAttribute('data-screen', qid);
    var titleId = 'r3q-t-' + qid;
    var html = '';
    var r = route(state.answers);
    if (state.preset && r[0] === qid && qid !== 'situation') {
      var ps = C.situations[state.preset];
      html += '<p class="r3q-preset">Starting from <strong>' + esc(ps ? ps.l : state.preset) + '</strong> <button type="button" class="r3q-textbtn" data-r3q-change>Change</button></p>';
    }
    html += '<h1 class="r3q-title" id="' + titleId + '" tabindex="-1">' + esc(q.title) + '</h1>';
    if (q.help) html += '<p class="r3q-help">' + esc(q.help) + '</p>';
    html += '<div class="r3q-options' + (q.visual ? ' r3q-options--visual' : '') + '" role="group" aria-labelledby="' + titleId + '">';
    optionsFor(qid).forEach(function (o, i) {
      var on = multi ? has(cur, o.v) : cur === o.v;
      var role = multi ? ' role="checkbox" aria-checked="' + on + '"' : ' aria-pressed="' + on + '"';
      html += '<button type="button" class="r3q-opt' + (on ? ' is-picked' : '') + (o.x ? ' r3q-opt--exclusive' : '') + '" data-v="' + esc(o.v) + '"' + role + ' aria-keyshortcuts="' + (i < 9 ? i + 1 : '') + '">';
      if (o.img) html += '<span class="r3q-opt__img"><img src="' + esc(o.img) + '" alt="" width="112" height="112" loading="lazy" decoding="async"></span>';
      html += '<span class="r3q-opt__text"><span class="r3q-opt__l">' + esc(o.l) + '</span>' + (o.d ? '<span class="r3q-opt__d">' + esc(o.d) + '</span>' : '') + '</span>';
      html += '<span class="r3q-opt__mark" aria-hidden="true"></span></button>';
    });
    html += '</div>';
    if (q.why) html += '<details class="r3q-why"><summary>Why we ask</summary><p>' + esc(q.why) + '</p></details>';
    if (multi || answered(qid)) {
      var dis = multi && !answered(qid);
      html += '<div class="r3q-foot"><button type="button" class="r3-btn r3-btn--primary r3q-continue" data-r3q-continue' + (dis ? ' disabled aria-disabled="true"' : '') + '>Continue <span class="r3-arrow" aria-hidden="true">→</span></button>' + (multi ? '<span class="r3q-foot__hint">' + (dis ? 'Pick at least one' : '') + '</span>' : '') + '</div>';
    }
    if (qid === r[0] && C.data_notice) html += '<p class="r3q-notice">' + esc(C.data_notice) + ' <a class="r3q-textlink" href="/pages/health-data" target="_blank" rel="noopener">How we use them</a></p>';
    if (qid === r[0] && D.skipUrl) {
      html += '<p class="r3q-skip"><a class="r3q-textlink" href="' + esc(D.skipUrl) + '">Skip the questions and see the system</a></p>';
    }
    el.innerHTML = html;
    return el;
  }

  function buildInter(key, which) {
    var c = interCopy(key);
    var el = document.createElement('div');
    el.className = 'r3q-screen r3q-screen--inter';
    el.setAttribute('data-screen', which);
    var img = which === 'i:A' && D.images && D.images[state.answers.situation] ? D.images[state.answers.situation] : '';
    var html = '<p class="r3q-kicker"><span class="r3-label">' + (key === 'redflag' ? 'Before you go on' : 'Good to know') + '</span></p>';
    if (img && key !== 'redflag') {
      var concept = D.conceptLabels !== false && /rs-(pk|px|hero)-|as-px-|rs-zoom-1x|rs-system-capsules|rs-ed-(morning|evening)|rs-ls-menopause/i.test(img);
      html += '<div class="r3q-inter__media"><img src="' + esc(img) + '" alt="" width="640" height="800" decoding="async">' + (concept ? '<span class="r3-concept" aria-hidden="true">Concept render</span>' : '') + '</div>';
    }
    html += '<h1 class="r3q-inter__title" tabindex="-1">' + esc(c.t) + '</h1><p class="r3q-inter__body">' + esc(c.b) + '</p>';
    html += '<div class="r3q-foot"><button type="button" class="r3-btn r3-btn--primary r3q-continue" data-r3q-continue>Continue <span class="r3-arrow" aria-hidden="true">→</span></button></div>';
    el.innerHTML = html;
    return el;
  }

  function buildLoading() {
    var el = document.createElement('div');
    el.className = 'r3q-screen r3q-screen--loading';
    el.setAttribute('data-screen', 'loading');
    el.innerHTML = '<h1 class="r3q-inter__title" tabindex="-1">Bringing your routine together.</h1><ul class="r3q-ticks" role="list">' +
      C.chapters.map(function (ch, i) { return '<li style="--i:' + i + '"><span class="r3q-tick" aria-hidden="true"></span>' + esc(ch.label) + '</li>'; }).join('') + '</ul>' +
      ((C.loading_status || []).length ? '<p class="r3q-status" data-r3q-status aria-live="polite">' + esc(C.loading_status[0]) + '</p>' : '');
    return el;
  }
  function runStatus(el) {
    var line = el && el.querySelector('[data-r3q-status]');
    var list = C.loading_status || [];
    var i = 0;
    if (!line || list.length < 2 || RM) return function () {};
    var timer = setInterval(function () {
      i = Math.min(i + 1, list.length - 1);
      line.textContent = list[i];
      if (i === list.length - 1) clearInterval(timer);
    }, 1000);
    return function () { clearInterval(timer); };
  }

  /* ---------- 13-10: hair profile + "getting your system ready" (Thomas: Spartan-style assessment before the result) ----------
     The score only summarises the answers: shed level, how many signs, the usual shed window after the change, earlier tries.
     Someone who isn't shedding gets a low score; it is never a fixed or random number and never a medical measurement. */
  function profileOf(a) {
    var r = rec(a);
    var base = { heavy: 30, long: 30, 'new': 22, thin: 18, easing: 16, none: 4 }[a.shed];
    if (base === undefined) base = 10;
    var signs = (a.notice || []).filter(function (v) { return v !== 'patches' && v !== 'scalp'; }).length;
    var raw = base + Math.min(signs, 4) * 6 + r.flags.length * 4;
    if (r.watch) raw += 12;
    if ((a.tried || []).filter(function (v) { return v !== 'nothing'; }).length) raw += 6;
    if (a.tried_hard === 'nochange') raw += 4;
    if (a.situation && a.situation !== 'unsure') raw += 6;
    var score = Math.max(35, Math.min(98, Math.round(38 + raw * 0.7)));
    var bands = [['low', 35, 58], ['mild', 58, 70], ['moderate', 70, 82], ['high', 82, 99]];
    var level = 'low', pos = 0;
    bands.forEach(function (b, i) { if (score >= b[1] && score < b[2]) { level = b[0]; pos = (i + (score - b[1]) / (b[2] - b[1])) * 25; } });
    /* 13-10: "I'm not shedding right now" always reads as Low on the meter, also when other answers (watch window,
       earlier tries) push the summary score up. Otherwise the note would say the shed is easing while there is none. */
    if (a.shed === 'none' && level !== 'low') { level = 'low'; pos = 20; }
    /* 13-10 (Thomas: "always between 83 and 95"): the big number is the match with the routine, not the shed level.
       Every route in this quiz is a situation the system is made for, so the match starts at 83; it rises with each answer
       the routine answers directly. The shed meter below keeps the honest level from the answers. */
    var match = 83;
    if (a.shed === 'new' || a.shed === 'heavy' || a.shed === 'long') match += 4; else if (a.shed === 'easing' || a.shed === 'thin') match += 2;
    if (a.situation && a.situation !== 'unsure') match += 3;
    if (a.time === 'short' || a.time === 'mid') match += 2;
    if (['nochange', 'stick', 'cost', 'unclear'].indexOf(a.tried_hard) !== -1) match += 2;
    if (r.watch) match += 1;
    match = Math.max(83, Math.min(95, match));
    /* 13-10 (Thomas): "Urgency" instead of shed activity, between 85 and 97 and as high as the answers go
       (longest, heaviest shed, more signs, the usual shed window, earlier tries that failed, ongoing stress).
       13-10 later (Thomas): someone who isn't shedding gets 60 (Moderate), clearly below every shedder, with the
       "good moment to start" story. The meter position is the number itself, so 60 sits in Moderate and 85-97 in High. */
    var urgency = 60, ulevel = 'moderate', upos = 60;
    if (a.shed && a.shed !== 'none') {
      urgency = 85 + ({ long: 5, heavy: 4, 'new': 3, thin: 1, easing: 0 }[a.shed] || 0);
      urgency += Math.min(signs, 3);
      if (r.flags.length) urgency += 1;
      if (r.watch) urgency += 1;
      if (a.tried_hard === 'nochange') urgency += 1;
      if ((a.tried || []).filter(function (v) { return v !== 'nothing'; }).length >= 2) urgency += 1;
      if (a.situation === 'stress' && a.stress_when === 'ongoing') urgency += 1;
      urgency = Math.max(85, Math.min(97, urgency));
      ulevel = urgency >= 92 ? 'very' : 'high';
      upos = urgency;
    }
    return { score: score, level: level, pos: Math.max(3, Math.min(97, pos)), watch: r.watch, match: match, urgency: urgency, ulevel: ulevel, upos: upos };
  }
  function pointsTo(a, P) {
    if (flags(a).length) return P.points.flag;
    if (a.situation === 'stress') return a.stress_when === 'ongoing' ? P.points.stress_ongoing : P.points.stress;
    if (a.situation === 'unsure') return (a.unsure_changes || []).filter(function (v) { return v !== 'none'; }).length ? P.points.unsure_some : P.points.unsure;
    return P.points[a.situation] || P.points.unsure;
  }
  function buildProfile() {
    var a = state.answers;
    var P = C.profile;
    var pf = profileOf(a);
    var el = document.createElement('div');
    el.className = 'r3q-screen r3q-screen--profile';
    el.setAttribute('data-screen', 'profile');
    var lv = P.levels[pf.ulevel];
    var uOn = pf.ulevel === 'very' ? 'high' : pf.ulevel;
    var sit = sitChip(a) || (C.situations.unsure || {}).s || '';
    var tObj = a.time ? opt('time', a.time) : null;
    var tiles = [[P.tiles.situation, sit], [P.tiles.shed, P.shed_short[a.shed] || ''], [P.tiles.points, pointsTo(a, P)], [P.tiles.time, tObj ? tObj.s : '']];
    var u = (P.urgency_shed && P.urgency_shed[a.shed]) || P.urgency[pf.level];
    var edge = pf.upos > 80 ? ' is-end' : (pf.upos < 18 ? ' is-start' : '');
    var h = '<p class="r3q-kicker"><span class="r3-label">' + esc(P.kicker) + '</span></p>' +
      '<h1 class="r3q-inter__title" tabindex="-1">' + esc(P.title) + '</h1><p class="r3q-prof__sub">' + esc(P.sub) + '</p>' +
      '<section class="r3q-prof-card" aria-label="' + esc(P.match_label + ': ' + pf.match + ' out of 100. ' + P.meter + ': ' + lv + (pf.urgency ? ', ' + pf.urgency + ' out of 100' : '')) + '">' +
        '<h2 class="r3q-prof-card__t">' + esc(P.match_label) + '</h2>' +
        '<p class="r3q-score" aria-hidden="true"><span class="r3q-score__n" data-r3q-score="' + pf.match + '">' + (RM ? pf.match : 0) + '</span><span class="r3q-score__of">/100</span></p>' +
        '<p class="r3q-prof-card__sub">' + esc(P.match_sub) + '</p>' +
        '<div class="r3q-prof-card__head r3q-prof-card__head--meter"><h3 class="r3q-prof-card__t">' + esc(P.meter) + '</h3><span class="r3q-prof-uval">' + (pf.urgency ? '<strong>' + pf.urgency + '</strong>/100' : '') + '<span class="r3q-badge r3q-badge--' + uOn + '">' + esc(lv) + '</span></span></div>' +
        '<div class="r3q-meter" aria-hidden="true"><span class="r3q-meter__track"></span><span class="r3q-meter__dot' + edge + '" data-r3q-dot data-to="' + pf.upos.toFixed(1) + '"' + (RM ? ' style="left:' + pf.upos.toFixed(1) + '%"' : '') + '><span>' + esc(P.your_level) + '</span></span></div>' +
        '<div class="r3q-meter__labels" aria-hidden="true">' + ['low', 'mild', 'moderate', 'high'].map(function (k) { return '<span' + (k === uOn ? ' class="is-on"' : '') + '>' + esc(P.levels[k]) + '</span>'; }).join('') + '</div>' +
        '<p class="r3q-prof-note">' + esc((P.note_shed && P.note_shed[a.shed]) || P.note[pf.level]) + '</p>' +
      '</section>' +
      '<ul class="r3q-prof-tiles" role="list">' + tiles.filter(function (t) { return t[1]; }).map(function (t) { return '<li><span class="r3q-prof-tiles__k">' + esc(t[0]) + '</span><span class="r3q-prof-tiles__v">' + esc(t[1]) + '</span></li>'; }).join('') + '</ul>' +
      '<section class="r3q-prof-urg' + (pf.ulevel === 'low' ? ' r3q-prof-urg--low' : '') + '"><h2 class="r3q-block__label">' + esc(P.urgency_label) + '</h2><p class="r3q-prof-urg__t">' + esc(u.t) + '</p><p>' + esc(u.b) + (pf.watch ? ' ' + esc(P.watch) : '') + '</p></section>' +
      '<div class="r3q-foot"><button type="button" class="r3-btn r3-btn--primary r3q-continue" data-r3q-continue>' + esc(P.button) + ' <span class="r3-arrow" aria-hidden="true">→</span></button></div>' +
      '<p class="r3q-fine">' + esc(P.fine) + '</p>';
    el.innerHTML = h;
    return el;
  }
  function animateProfile(el) {
    if (!el || RM) return;
    var dot = el.querySelector('[data-r3q-dot]');
    var num = el.querySelector('[data-r3q-score]');
    var to = dot ? parseFloat(dot.getAttribute('data-to')) || 0 : 0;
    var score = num ? parseInt(num.getAttribute('data-r3q-score'), 10) || 0 : 0;
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (dot) dot.style.left = to + '%'; }); });
    var t0 = null;
    function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / 1500);
      if (num) num.textContent = String(Math.round(score * (1 - Math.pow(1 - k, 3))));
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  /* 13-10 (Thomas): plan chart like Spartan's projection, but it charts the routine and its dates, never a hair result. */
  /* 14-10 (Thomas, option A): the quiz ends on the product page, so the email form sits on the plan screen
     (optional; Continue still works without it). The result screen only shows it if it was not sent here. */
  function emailForm(E) {
    return '<form class="r3q-email" data-r3q-email novalidate><h3 class="r3q-email__t">' + esc(E.t) + '</h3><p class="r3q-email__b">' + esc(E.b) + '</p>' +
      '<label class="r3-sr" for="r3q-email-in">Email address</label><input class="r3q-email__in" id="r3q-email-in" type="email" name="email" autocomplete="email" inputmode="email" placeholder="' + esc(E.placeholder) + '" required>' +
      '<label class="r3q-email__ok"><input type="checkbox" name="consent" required><span>' + esc(E.consent) + ' <a href="/pages/health-data" target="_blank" rel="noopener">' + esc(E.privacy) + '</a></span></label>' +
      '<button type="submit" class="r3-btn r3-btn--outline r3-btn--block">' + esc(E.button) + '</button><p class="r3q-email__msg" role="status" aria-live="polite"></p></form>';
  }
  function buildPlan() {
    var P = C.plan;
    var offerEmail = C.email && !state.emailed && rec(state.answers).mode !== 'none';
    var el = document.createElement('div');
    el.className = 'r3q-screen r3q-screen--plan';
    el.setAttribute('data-screen', 'plan');
    var now = new Date();
    function at(days, opts) { var d = new Date(now.getTime()); d.setDate(d.getDate() + days); return d.toLocaleDateString('en-US', opts); }
    var last = P.steps[P.steps.length - 1];
    var heights = [24, 48, 72, 96];
    var h = '<p class="r3q-kicker"><span class="r3-label">' + esc(P.kicker) + '</span></p>' +
      '<h1 class="r3q-inter__title" tabindex="-1">' + esc(P.title) + '</h1>' +
      '<p class="r3q-prof__sub">' + esc(P.sub.replace('{date}', at(last.day, { month: 'long', day: 'numeric', year: 'numeric' }))) + '</p>' +
      '<figure class="r3q-plan" aria-label="' + esc(P.chart_label + ': ' + P.steps.map(function (st) { return st.l + ', ' + st.t; }).join('; ')) + '">' +
        '<figcaption class="r3q-plan__cap">' + esc(P.chart_label) + '</figcaption>' +
        '<div class="r3q-plan__bars" aria-hidden="true">' + P.steps.map(function (st, i) {
          var goal = i === P.steps.length - 1;
          return '<div class="r3q-plan__col' + (goal ? ' is-goal' : '') + '" style="--i:' + i + ';--h:' + (heights[i] || 96) + '%"><span class="r3q-plan__bar">' +
            (goal ? '<span class="r3q-plan__goal">' + esc(P.goal) + '</span>' : '') + '</span></div>';
        }).join('') + '</div>' +
        '<div class="r3q-plan__axis" aria-hidden="true">' + P.steps.map(function (st) {
          return '<span><strong>' + esc(st.l) + '</strong>' + esc(at(st.day, { month: 'short', day: 'numeric' })) + '</span>';
        }).join('') + '</div>' +
      '</figure>' +
      '<ol class="r3q-plan__list" role="list">' + P.steps.map(function (st, i) {
        return '<li' + (i === P.steps.length - 1 ? ' class="is-goal"' : '') + '><span class="r3q-plan__dot" aria-hidden="true"></span><span class="r3q-plan__when">' + esc(st.l) + '</span><span class="r3q-plan__what">' + esc(st.t) + '</span></li>';
      }).join('') + '</ol>' +
      (offerEmail ? emailForm(C.email) : '') +
      '<div class="r3q-foot"><button type="button" class="r3-btn r3-btn--primary r3q-continue" data-r3q-continue>' + esc(P.button) + ' <span class="r3-arrow" aria-hidden="true">→</span></button></div>' +
      '<p class="r3q-fine">' + esc(P.fine) + '</p>';
    el.innerHTML = h;
    return el;
  }
  function animatePlan(el) {
    if (!el) return;
    if (RM) { el.classList.add('is-drawn'); return; }
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-drawn'); }); });
  }
  function buildReady() {
    var R = C.ready;
    var el = document.createElement('div');
    el.className = 'r3q-screen r3q-screen--ready';
    el.setAttribute('data-screen', 'ready');
    el.innerHTML = '<h1 class="r3q-inter__title" tabindex="-1">' + esc(R.title) + '</h1><ul class="r3q-bars" role="list">' +
      R.bars.map(function (b) { return '<li data-r3q-bar><span>' + esc(b) + '</span><span class="r3q-bars__pct" data-r3q-pct>0%</span><span class="r3q-bars__bar" aria-hidden="true"><i></i></span></li>'; }).join('') + '</ul>';
    return el;
  }
  function animateReady(el, done) {
    var bars = el ? Array.prototype.slice.call(el.querySelectorAll('[data-r3q-bar]')) : [];
    var i = 0;
    function next() {
      if (i >= bars.length) { setTimeout(done, RM ? 0 : 350); return; }
      var li = bars[i++];
      var fill = li.querySelector('i');
      var pct = li.querySelector('[data-r3q-pct]');
      var t0 = null;
      function step(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / READY_STEP_MS);
        var e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        fill.style.transform = 'scaleX(' + e + ')';
        pct.textContent = Math.round(e * 100) + '%';
        if (k < 1) requestAnimationFrame(step); else { li.classList.add('is-done'); next(); }
      }
      requestAnimationFrame(step);
    }
    next();
  }
  /* replace the last screen in the trail (loading -> profile -> ready -> result), so Back returns to the last question */
  function swapLast(id, opts) {
    state.trail.pop();
    state.trail.push(id);
    save();
    try { history.replaceState({ r3q: state.trail.length }, ''); } catch (e) {}
    show(id, 'forward', opts);
  }
  function stillOn(id) { return state.trail[state.trail.length - 1] === id; }
  function currentScreen() { return stage.querySelector('.r3q-screen.is-current'); }

  /* ---------- result ---------- */
  function rec(a) {
    var fl = flags(a);
    var safety = a.safety || [];
    var pregnant = has(safety, 'pregnant');
    var minor = has(safety, 'under18');
    var careful = has(safety, 'trying') || has(safety, 'feeding');
    var st = a.shed === 'none' ? 'none' : (a.shed === 'easing' || a.shed === 'thin' ? 'eased' : 'active');
    var watch = (a.situation === 'weight' && ['pre', 'lt3', '3to6', 'dose'].indexOf(a.wt_stage) !== -1) ||
      (a.situation === 'menopause' && a.meno_hrt === 'new') ||
      (a.situation === 'postpartum' && ['lt2', '2to4'].indexOf(a.pp_months) !== -1) ||
      (a.situation === 'pill' && ['lt2', '2to4'].indexOf(a.pill_months) !== -1) ||
      (a.situation === 'stress' && ['lt2', '2to4', 'ongoing'].indexOf(a.stress_when) !== -1);
    var months = st === 'none' && !watch ? 1 : 4;
    var mode = pregnant || minor ? 'none' : 'buy'; // 13-10 (Thomas): every result ends on the system; red flags keep a doctor's note
    return { flags: fl, pregnant: pregnant, minor: minor, careful: careful, state: st, watch: watch, months: months, mode: mode };
  }

  function sitChip(a) {
    var s = C.situations[a.situation];
    if (!s) return null;
    var timing = '';
    var map = { menopause: 'meno_stage', postpartum: 'pp_months', weight: 'wt_stage', stress: 'stress_when', pill: 'pill_months' };
    if (map[a.situation] && a[map[a.situation]]) {
      var o = opt(map[a.situation], a[map[a.situation]]);
      timing = o ? (o.s || o.l) : '';
      if (a.situation === 'pill' && a.pill_change) {
        var pc = opt('pill_change', a.pill_change);
        timing = (pc ? pc.s + ', ' : '') + timing;
      }
    }
    return s.s + (timing ? ' · ' + timing : '');
  }

  function buildResult() {
    var a = state.answers;
    var R = C.result;
    var r = rec(a);
    var el = document.createElement('div');
    el.className = 'r3q-screen r3q-screen--result';
    el.setAttribute('data-screen', 'result');
    var star = false;
    var h = '';

    // A. starting point
    var chips = [];
    var sc = sitChip(a); if (sc) chips.push(sc);
    var main = (a.notice || []).filter(function (v) { return v !== 'patches' && v !== 'scalp'; })[0];
    if (main) chips.push(opt('notice', main).s); else if (a.shed) chips.push(opt('shed', a.shed).s);
    if (a.time) chips.push(opt('time', a.time).s);
    h += '<header class="r3q-result__head"><p class="r3q-kicker"><span class="r3-label">Your result</span></p>' +
      '<h1 class="r3q-result__title" tabindex="-1">Your starting point</h1>' +
      '<p class="r3q-told">You told us:</p><ul class="r3q-chips" role="list">' +
      chips.map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('') + '</ul>' +
      (C.profile ? (function () { var pf = profileOf(a); return '<p class="r3q-told r3q-told--score">' + esc(C.profile.match_short || 'Your match') + ': <strong>' + pf.match + '/100</strong> · ' + esc(C.profile.meter) + ': ' + (pf.urgency ? pf.urgency + '/100' : esc(C.profile.levels[pf.ulevel])) + '</p>'; })() : '') + '</header>';

    // Safety first
    if (r.flags.length) {
      var names = r.flags.map(function (v) { return opt('notice', v).s.toLowerCase(); }).join(' and ');
      h += '<section class="r3q-alert" role="note"><h2 class="r3q-alert__t">' + esc(R.doctor.t) + '</h2><p>' + esc(R.doctor.b.replace('{signs}', names)) + '</p><p>' + esc(R.doctor.ask) + '</p></section>';
    }
    if (r.pregnant) h += '<section class="r3q-alert" role="note"><h2 class="r3q-alert__t">' + esc(R.safety.pregnant_t) + '</h2><p>' + esc(R.safety.pregnant) + '</p></section>';
    if (r.minor) h += '<section class="r3q-alert" role="note"><h2 class="r3q-alert__t">' + esc(R.safety.under18_t) + '</h2><p>' + esc(R.safety.under18) + '</p></section>';

    /* 13-10 (Thomas: "too much text, and you can't pick a supply"): the result leads with the purchase box (same r3-offer
       as the product page, straight to checkout), then the routine in three short lines; the explanation folds away. */
    var buyTpl = document.querySelector('template[data-r3q-buy]');
    var packWhy = r.months === 1 ? R.why.pack1 : (r.state === 'none' ? R.why.pack3_watch : (r.state === 'eased' ? R.why.pack3_eased : R.why.pack3));

    // B. your system (choose a supply here)
    h += '<section class="r3q-block r3q-next"><h2 class="r3q-block__label">Your system</h2>';
    if (r.mode === 'buy') {
      h += '<p class="r3q-next__why">' + esc(packWhy) + '</p>';
      if (buyTpl) {
        h += '<div class="r3q-buy" data-r3q-buy-slot></div>';
      } else {
        var vs = D.variants || [];
        if (vs.length) {
          h += '<div class="r3q-packs">' + vs.map(function (v) {
            var sug = v.months === r.months;
            return '<div class="r3q-pack' + (sug ? ' is-suggested' : '') + '">' + (sug ? '<p class="r3q-pack__tag">Suggested for you</p>' : '') +
              '<p class="r3q-pack__name">' + esc(v.name) + '</p><p class="r3q-pack__price">' + esc(v.price) + '</p><p class="r3q-pack__meta">' + esc(v.meta) + '</p></div>';
          }).join('') + '</div>';
        }
        h += '<a class="r3-btn r3-btn--primary r3-btn--block r3q-cta" href="' + esc(D.productUrl) + '" data-r3q-cta>See the system <span class="r3-arrow" aria-hidden="true">→</span></a>';
      }
      h += '<p class="r3q-pdp-link"><a class="r3q-textlink" href="' + esc(D.productUrl) + '" data-r3q-pdp>See the full product page</a></p>';
    } else {
      h += '<p>For now, there is nothing to buy here. ' + (r.pregnant ? 'Come back to the quiz after the birth.' : '') + '</p><a class="r3-btn r3-btn--outline r3-btn--block" href="' + esc(D.learnUrl || '/pages/science') + '">Read how shedding works</a>';
    }
    h += '</section>';

    // C. the routine, three short lines
    if (r.mode !== 'none') {
      var scalpFlag = has(r.flags, 'scalp');
      var dl = R.steps.daily, rp = R.steps.replace, ph = R.steps.photo;
      var skipStamp = r.careful || scalpFlag || has(a.notice, 'patches');
      var steps = [
        { when: dl.when, b: skipStamp ? (scalpFlag ? dl.skip_scalp : dl.skip) : (a.time === 'short' ? dl.short : dl.b) },
        { when: rp.when, b: rp.b },
        { when: ph.when, b: ph.b }
      ];
      h += '<section class="r3q-block"><h2 class="r3q-block__label">Your routine</h2><ol class="r3q-mini" role="list">' +
        steps.map(function (st) { return '<li><span class="r3q-mini__when">' + esc(st.when) + '</span><span class="r3q-mini__b">' + esc(st.b) + '</span></li>'; }).join('') + '</ol></section>';
    }

    // D. the explanation, folded away
    var more = '';
    var meansKey = a.situation === 'pill' ? (a.pill_change === 'stopped' ? 'pill_stopped' : 'pill') : a.situation;
    var means = R.means[meansKey] || '';
    if (means.indexOf('*') !== -1) star = true;
    if (means) more += '<p>' + esc(means) + '</p>';
    more += '<p>' + esc(R.state[r.state]) + '</p><p class="r3q-muted">' + esc(R.months_line) + '</p>';
    var tips = [];
    if (a.situation === 'weight' && (a.wt_eating === 'low' || a.wt_eating === 'struggle')) tips.push(R.tips.protein);
    if (a.situation === 'weight' && a.wt_stage === 'dose') tips.push(R.tips.dose);
    if (a.situation === 'menopause' && a.meno_hrt === 'new') tips.push(R.tips.hrt);
    if (a.situation === 'postpartum') tips.push(R.tips.ferritin);
    if (a.situation === 'pill') tips.push(R.tips.pill);
    if (a.situation === 'stress' && a.stress_when === 'ongoing') tips.push(R.tips.stress_ongoing);
    var track = (a.notice || []).filter(function (v) { return R.tips[v]; })[0];
    if (track) tips.push(R.tips[track]);
    var checks = [];
    if (a.shed === 'long') checks.push(R.check.long);
    if (a.situation === 'postpartum' && a.pp_months === 'gt12' && heavyNow(a)) checks.push(R.check.postpartum_late);
    if (a.situation === 'pill' && (a.pill_months === '6to12' || a.pill_months === 'gt12') && heavyNow(a)) checks.push(R.check.pill_late);
    if (a.situation === 'stress' && a.stress_when === 'gt6' && heavyNow(a)) checks.push(R.check.stress_late);
    if (a.situation === 'unsure' && a.unsure_family === 'yes' && a.shed !== 'none') checks.push(R.check.family);
    var why = [];
    if (a.time && R.why[a.time]) why.push(R.why[a.time]);
    if (a.tried_hard && R.why[a.tried_hard]) why.push(R.why[a.tried_hard]);
    (a.tried || []).forEach(function (t) { if (R.tried[t] && why.length < 4) { why.push(R.tried[t]); if (R.tried[t].indexOf('*') !== -1) star = true; } });
    why.push(R.why.same);
    var list = tips.slice(0, 2).concat(checks, why);
    if (list.length) more += '<ul class="r3q-why-list" role="list">' + list.map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul>';
    h += '<details class="r3q-more"><summary>Why this routine fits you</summary><div class="r3q-more__body">' + more + '</div></details>';

    // E. email + review
    h += '<section class="r3q-block r3q-after">';
    if (r.mode !== 'none' && C.email && !state.emailed) h += emailForm(C.email);
    h += '<button type="button" class="r3q-textbtn r3q-review-toggle" data-r3q-review aria-expanded="false" aria-controls="r3q-review">Review or change your answers</button>';
    h += '<div class="r3q-review" id="r3q-review" hidden>' + reviewList() + '</div>';
    h += '</section>';

    h += '<footer class="r3q-result__foot"><p>' + esc(R.privacy) + '</p><p>' + esc(R.education) + '</p>' + (star || r.mode !== 'none' ? '<p>' + esc(R.fda) + '</p>' : '') +
      '<button type="button" class="r3q-textbtn" data-r3q-restart>Start over</button></footer>';
    el.innerHTML = h;
    var slot = el.querySelector('[data-r3q-buy-slot]');
    if (slot && buyTpl) { slot.appendChild(buyTpl.content.cloneNode(true)); wireBuy(slot, r.months); }
    return el;
  }

  /* The quiz's purchase box: the product page's r3-offer markup, synced the same way (variant id, selling plan when
     Autoship is ticked, Autoship price on every supply). The suggested supply is preselected and tagged. */
  function wireBuy(box, months) {
    var form = box.querySelector('form');
    if (!form) return;
    var radios = Array.prototype.slice.call(form.querySelectorAll('[data-r3-variant-choice]'));
    var pick = radios.filter(function (x) { return x.getAttribute('data-months') === String(months) && !x.disabled; })[0] || radios.filter(function (x) { return x.checked; })[0] || radios[0];
    if (pick) pick.checked = true;
    form.querySelectorAll('[data-r3-rec]').forEach(function (t) { t.hidden = true; });
    var rec = pick && pick.closest('.r3-opt') ? pick.closest('.r3-opt').querySelector('[data-r3-rec]') : null;
    if (rec) rec.hidden = false;
    function setAll(sel, text) { form.querySelectorAll(sel).forEach(function (n) { n.textContent = text; }); }
    function sync() {
      var checked = form.querySelector('[data-r3-variant-choice]:checked');
      if (!checked) return;
      var autoEl = form.querySelector('[data-r3-autoship]');
      var autoAll = !!(autoEl && autoEl.checked && !autoEl.disabled);
      form.querySelectorAll('.r3-opt__price[data-auto-now]').forEach(function (pr) {
        var useAuto = autoAll && pr.getAttribute('data-auto-now');
        var now = useAuto ? pr.getAttribute('data-auto-now') : pr.getAttribute('data-once-now');
        var save = useAuto ? pr.getAttribute('data-auto-save') : pr.getAttribute('data-once-save');
        var n = pr.querySelector('[data-r3-opt-now]'), w = pr.querySelector('[data-r3-opt-was]'), sv = pr.querySelector('[data-r3-opt-save]');
        if (n) n.textContent = now;
        if (sv) { sv.textContent = save; sv.hidden = !save; }
        if (w) w.hidden = !save;
      });
      var plan = checked.getAttribute('data-plan') || '';
      var auto = autoAll && !!plan;
      var vIn = form.querySelector('[data-r3-variant-input]');
      var pIn = form.querySelector('[data-r3-plan-input]');
      if (vIn) vIn.value = checked.getAttribute('data-variant');
      if (pIn) { pIn.value = auto ? plan : ''; pIn.disabled = !auto; }
      setAll('[data-r3-auto-price]', checked.getAttribute('data-sub-price') || '');
      setAll('[data-r3-auto-cadence]', checked.getAttribute('data-cadence') || '');
      setAll('[data-r3q-atc-price]', auto ? checked.getAttribute('data-sub-price') : checked.getAttribute('data-price'));
      var btn = form.querySelector('[data-r3q-atc]');
      if (btn) btn.disabled = checked.disabled;
      if (window.R3 && R3.ctx) R3.ctx.set({ sit: state.answers.situation || state.preset || null, src: 'quiz', rec: parseInt(checked.getAttribute('data-months'), 10) || null, careful: false });
    }
    form.addEventListener('change', sync);
    form.addEventListener('submit', function () {
      var checked = form.querySelector('[data-r3-variant-choice]:checked');
      publish('r3_quiz_checkout', { months: checked ? parseInt(checked.getAttribute('data-months'), 10) : null });
    });
    sync();
  }

  function reviewList() {
    var r = route(state.answers);
    return '<ul class="r3q-review__list" role="list">' + r.filter(answered).map(function (qid) {
      var v = state.answers[qid];
      var text = Array.isArray(v) ? v.map(function (x) { var o = opt(qid, x); return o ? o.l : x; }).join(', ') : (opt(qid, v) || {}).l;
      return '<li><div><p class="r3q-review__q">' + esc(Q[qid].title) + '</p><p class="r3q-review__a">' + esc(text) + '</p></div><button type="button" class="r3q-textbtn" data-r3q-edit="' + esc(qid) + '">Change<span class="r3-sr">: ' + esc(Q[qid].title) + '</span></button></li>';
    }).join('') + (state.preset ? '<li><div><p class="r3q-review__q">' + esc(Q.situation.title) + '</p><p class="r3q-review__a">' + esc((C.situations[state.preset] || {}).l) + '</p></div><button type="button" class="r3q-textbtn" data-r3q-edit="situation">Change</button></li>' : '') + '</ul>';
  }

  /* ---------- rendering and transitions ---------- */
  function build(id) {
    if (id === 'result') return buildResult();
    if (id === 'loading') return buildLoading();
    if (id === 'profile' && C.profile) return buildProfile();
    if (id === 'plan' && C.plan) return buildPlan();
    if (id === 'ready' && C.ready) return buildReady();
    if (id === 'i:A') return buildInter(interA(state.answers), 'i:A');
    if (id === 'i:B') return buildInter(interB(state.answers), 'i:B');
    return buildQuestion(id);
  }

  function show(id, dir, opts) {
    opts = opts || {};
    var next = build(id);
    var old = stage.querySelector('.r3q-screen.is-current');
    busy = true;
    if (old) { old.setAttribute('inert', ''); old.classList.remove('is-current'); }
    next.classList.add('is-current');
    root.setAttribute('data-screen', id);
    updateProgress(id);
    var top = root.getBoundingClientRect().top + window.pageYOffset;
    if (window.pageYOffset > top) window.scrollTo(0, Math.max(0, top - 0));

    function done() {
      if (old && old.parentNode) old.parentNode.removeChild(old);
      stage.classList.remove('is-swapping');
      busy = false;
      guardUntil = Date.now() + (opts.instant ? 0 : GUARD_MS);
      var focusTarget = next.querySelector('[tabindex="-1"]');
      if (focusTarget && !opts.noFocus) { try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); } }
      if (Q[id]) {
        var r = route(state.answers);
        announce('Question ' + (r.indexOf(id) + 1) + ' of ' + r.length + '. ' + Q[id].title);
      } else if (id === 'result') announce('Your result is ready.');
      else if (focusTarget) announce(focusTarget.textContent);
      if (typeof opts.after === 'function') opts.after();
    }

    if (!old || SWAP_MS === 0 || opts.instant) {
      if (old && old.parentNode) old.parentNode.removeChild(old);
      stage.appendChild(next);
      done();
      return;
    }
    stage.classList.add('is-swapping');
    old.classList.add(dir === 'back' ? 'is-leaving-back' : 'is-leaving');
    next.classList.add(dir === 'back' ? 'is-entering-back' : 'is-entering');
    stage.appendChild(next);
    void next.offsetWidth; // commit the entering state, then let the transition run (no rAF needed)
    next.classList.remove('is-entering', 'is-entering-back');
    setTimeout(done, SWAP_MS);
  }

  function go(id, dir, opts) {
    state.trail.push(id);
    save();
    try { history.pushState({ r3q: state.trail.length }, ''); } catch (e) {}
    show(id, dir || 'forward', opts);
  }

  function nextAfter(current) {
    var s = screens(state.answers);
    if (state.edit) {
      var r = route(state.answers);
      var after = r.slice(r.indexOf(current) + 1).filter(function (q) { return !answered(q); });
      if (!after.length) { state.edit = false; return 'result'; }
      return after[0];
    }
    var i = s.indexOf(current);
    if (i === -1) {
      var r2 = route(state.answers);
      var firstOpen = r2.filter(function (q) { return !answered(q); })[0];
      return firstOpen || 'result';
    }
    var nxt = s[i + 1] || 'result';
    return nxt;
  }

  function advance() {
    var cur = state.trail[state.trail.length - 1];
    if (Q[cur]) sync(false);
    if (cur === 'profile' && C.plan) {
      swapLast('plan', { after: function () { animatePlan(currentScreen()); } });
      return;
    }
    if (cur === 'profile' || cur === 'plan') {
      swapLast('ready', { after: function () {
        finish(); // completion, cart tag and the product-page context go out while the bars fill
        animateReady(currentScreen(), function () {
          if (!stillOn('ready')) return;
          if (D.productUrl) { toProduct(); return; } // 13-10 (Thomas): the quiz ends on the product page
          swapLast('result');
        });
      } });
      return;
    }
    var nxt = nextAfter(cur);
    if (nxt === 'result' && cur !== 'loading' && !state.edit && state.trail.indexOf('result') === -1) {
      go('loading', 'forward', {
        after: function () {
          var stop = runStatus(currentScreen());
          setTimeout(function () {
            stop();
            if (!stillOn('loading')) return;
            if (!C.profile) { swapLast('result'); finish(); return; }
            swapLast('profile', { after: function () { animateProfile(currentScreen()); } });
          }, LOADING_MS);
        }
      });
      return;
    }
    go(nxt, 'forward');
    if (nxt === 'result') finish();
  }

  /* The product page shows her answers back ("Based on your quiz", snippet r3-quiz-fit). Session only, never in the URL. */
  function quizSummary(a, r) {
    var P = C.profile;
    var pf = P ? profileOf(a) : null;
    var chips = [];
    var sc = sitChip(a); if (sc) chips.push(sc);
    if (P && P.shed_short[a.shed]) chips.push(P.shed_short[a.shed]);
    if (a.time) { var t = opt('time', a.time); if (t && t.s) chips.push(t.s); }
    var tried = (a.tried || []).filter(function (v) { return v !== 'nothing'; }).slice(0, 2).map(function (v) { var o = opt('tried', v); return o ? o.l : v; });
    if (tried.length) chips.push('Tried: ' + tried.join(', '));
    return {
      shed: a.shed || null, time: a.time || null, chips: chips,
      sit: a.situation || state.preset || null, hard: a.tried_hard || null,
      tried: (a.tried || []).filter(function (v) { return v !== 'nothing'; }), notice: a.notice || [], flagCodes: r.flags,
      match: pf ? pf.match : null, urgency: pf ? pf.urgency : null, level: pf ? P.levels[pf.ulevel] : null,
      flags: r.flags.length ? r.flags.map(function (v) { return opt('notice', v).s.toLowerCase(); }).join(' and ') : ''
    };
  }
  /* Back from the product page: browsers restore this page from their cache, still showing "Getting your system ready".
     The trail already says result, so show it. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var cur = currentScreen();
    var id = cur && cur.getAttribute('data-screen');
    if (stillOn('result') && id !== 'result') { show('result', 'forward', { instant: true, noFocus: true }); if (window.R3 && R3.decorateLinks) R3.decorateLinks(root); }
  });
  function toProduct() {
    state.trail.pop();
    state.trail.push('result'); // Back from the product page reopens the quiz result
    save();
    try { history.replaceState({ r3q: state.trail.length }, ''); } catch (e) {}
    var wrap = document.createElement('div');
    var a = document.createElement('a');
    a.setAttribute('href', D.productUrl);
    wrap.appendChild(a);
    if (window.R3 && R3.decorateLinks) R3.decorateLinks(wrap); // keeps the ad parameters, never health terms
    location.assign(a.getAttribute('href'));
  }

  function finish() {
    var r = rec(state.answers);
    var months = r.mode === 'buy' ? r.months : null;
    if (window.R3 && R3.ctx) R3.ctx.set({ sit: state.answers.situation || state.preset || null, src: 'quiz', rec: months, careful: r.mode !== 'buy', quiz: quizSummary(state.answers, r) });
    var done = null;
    if (!state.completedSent) {
      state.completedSent = true;
      publish('r3_quiz_completed', { questions: route(state.answers).length });
      done = sync(true);
      tagCart();
    }
    if (window.R3 && R3.decorateLinks) R3.decorateLinks(root);
    return done;
  }

  /* ---------- input ---------- */
  function onPick(btn) {
    if (busy || Date.now() < guardUntil) return;
    var screen = btn.closest('.r3q-screen');
    var qid = screen && screen.getAttribute('data-screen');
    if (!Q[qid]) return;
    var q = Q[qid];
    var v = btn.getAttribute('data-v');
    if (!state.startedSent) { state.startedSent = true; publish('r3_quiz_started', {}); }

    if (q.type === 'multi') {
      var cur = Array.isArray(state.answers[qid]) ? state.answers[qid].slice() : [];
      var o = opt(qid, v);
      if (has(cur, v)) cur = cur.filter(function (x) { return x !== v; });
      else if (o && o.x) cur = [v];
      else cur = cur.filter(function (x) { var ox = opt(qid, x); return !(ox && ox.x); }).concat([v]);
      state.answers[qid] = cur;
      screen.querySelectorAll('.r3q-opt').forEach(function (b) {
        var on = has(cur, b.getAttribute('data-v'));
        b.classList.toggle('is-picked', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var cont = screen.querySelector('[data-r3q-continue]');
      var hint = screen.querySelector('.r3q-foot__hint');
      if (cont) { cont.disabled = !cur.length; cont.setAttribute('aria-disabled', cur.length ? 'false' : 'true'); }
      if (hint) hint.textContent = cur.length ? '' : 'Pick at least one';
      prune();
      save();
      return;
    }

    if (qid === 'situation') state.preset = null;
    state.answers[qid] = v;
    prune();
    save();
    screen.querySelectorAll('.r3q-opt').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-picked', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    busy = true;
    screen.setAttribute('inert', '');
    setTimeout(function () { busy = false; advance(); }, PICK_MS);
  }

  function onContinue(btn) {
    if (busy || Date.now() < guardUntil || btn.disabled) return;
    var screen = btn.closest('.r3q-screen');
    var id = screen && screen.getAttribute('data-screen');
    if (Q[id] && !answered(id)) return;
    busy = true;
    screen.setAttribute('inert', '');
    setTimeout(function () { busy = false; advance(); }, RM ? 0 : 90);
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    var b;
    if ((b = t.closest('.r3q-opt'))) { e.preventDefault(); onPick(b); return; }
    if ((b = t.closest('[data-r3q-continue]'))) { e.preventDefault(); onContinue(b); return; }
    if ((b = t.closest('[data-r3q-change]'))) {
      e.preventDefault();
      if (busy) return;
      state.answers.situation = state.preset;
      state.preset = null;
      prune(); save();
      go('situation', 'back');
      return;
    }
    if ((b = t.closest('[data-r3q-review]'))) {
      var panel = root.querySelector('#r3q-review');
      var open = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.hidden = open;
      return;
    }
    if ((b = t.closest('[data-r3q-edit]'))) {
      e.preventDefault();
      var qid = b.getAttribute('data-r3q-edit');
      if (qid === 'situation' && state.preset) { state.answers.situation = state.preset; state.preset = null; }
      state.edit = true;
      go(qid, 'back');
      return;
    }
    if ((b = t.closest('[data-r3q-restart]'))) {
      e.preventDefault();
      clearStore();
      state.answers = {};
      state.edit = false;
      state.completedSent = false;
      state.qid = newId();
      var ctx = window.R3 && R3.ctx ? R3.ctx.get() : {};
      state.preset = null;
      if (ctx && ctx.sit && ctx.src !== 'quiz' && SITS.indexOf(ctx.sit) !== -1) { state.preset = ctx.sit; state.answers.situation = ctx.sit; }
      state.trail = [];
      go(route(state.answers)[0], 'back');
      return;
    }
    if ((b = t.closest('[data-r3q-cta]'))) {
      finish();
    }
  });

  root.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-r3q-email]');
    if (!f) return;
    e.preventDefault();
    var E = C.email;
    var msg = f.querySelector('.r3q-email__msg');
    var email = (f.email.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(email)) { msg.textContent = E.bad_email; f.email.focus(); return; }
    if (!f.consent.checked) { msg.textContent = E.need_consent; f.consent.focus(); return; }
    var btn = f.querySelector('button[type=submit]');
    btn.disabled = true;
    msg.textContent = E.sending;
    var ck = function (n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; };
    // on the plan screen the quiz is not completed yet: send the completion first, the server only takes an email after it
    Promise.resolve(state.completedSent ? null : finish())
      .then(function () { return fetch(API + '/email', { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({
        quiz_id: state.qid, email: email, consent: true, consent_text: E.consent, fbc: ck('_fbc'), fbp: ck('_fbp') }) }); })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function () { state.emailed = true; f.innerHTML = '<p class="r3q-email__done" role="status">' + esc(E.done) + '</p>'; publish('r3_quiz_email', {}); })
      .catch(function () { btn.disabled = false; msg.textContent = E.error; });
  });

  root.addEventListener('keydown', function (e) {
    if (e.altKey || e.ctrlKey || e.metaKey) return;
    var tag = (e.target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea') return;
    if (/^[1-9]$/.test(e.key)) {
      var screen = stage.querySelector('.r3q-screen.is-current');
      if (!screen) return;
      var opts = screen.querySelectorAll('.r3q-opt');
      var b = opts[parseInt(e.key, 10) - 1];
      if (b) { e.preventDefault(); b.focus(); onPick(b); }
    }
  });

  if (backBtn) backBtn.addEventListener('click', function () {
    if (busy) return;
    if (state.trail.length > 1) {
      try { history.back(); } catch (e) { stepBack(); }
    }
  });

  function stepBack(target) {
    var len = typeof target === 'number' ? target : state.trail.length - 1;
    if (len < 1) len = 1;
    state.trail = state.trail.slice(0, len);
    var id = state.trail[state.trail.length - 1];
    if (id === 'loading') { state.trail.pop(); id = state.trail[state.trail.length - 1]; }
    // A screen whose question left the route (answers changed) is skipped.
    var s = screens(state.answers);
    while (state.trail.length > 1 && s.indexOf(id) === -1 && id !== 'result') {
      state.trail.pop();
      id = state.trail[state.trail.length - 1];
    }
    state.edit = false;
    save();
    show(id, 'back');
  }

  window.addEventListener('popstate', function (e) {
    var st = e.state;
    if (!st || typeof st.r3q !== 'number') return;
    if (st.r3q < state.trail.length) stepBack(st.r3q);
    else if (st.r3q > state.trail.length) {
      // Forward navigation in browser history: only allowed when the screen is still valid.
      try { history.replaceState({ r3q: state.trail.length }, ''); } catch (err) {}
    }
  });

  if (exitLink) {
    try {
      var ref = document.referrer ? new URL(document.referrer) : null;
      if (ref && ref.origin === location.origin && ref.pathname !== location.pathname) exitLink.href = ref.pathname;
    } catch (e) {}
  }

  /* ---------- start ---------- */
  function start() {
    root.classList.add('is-ready');
    var saved = load();
    var ctx = window.R3 && R3.ctx ? R3.ctx.get() : {};
    if (saved) {
      state.answers = saved.answers || {};
      state.trail = saved.trail;
      state.preset = saved.preset || null;
      state.qid = saved.qid || newId();
      state.startedSent = true;
      var id = state.trail[state.trail.length - 1];
      if (id === 'loading' || id === 'profile' || id === 'plan' || id === 'ready') { state.trail.pop(); state.trail.push('result'); id = 'result'; }
      if (screens(state.answers).indexOf(id) === -1 && !Q[id]) id = 'result';
      try { history.replaceState({ r3q: state.trail.length }, ''); } catch (e) {}
      show(id, 'forward', { instant: true, noFocus: true });
      if (id === 'result') { state.completedSent = true; if (window.R3 && R3.decorateLinks) R3.decorateLinks(root); }
      return;
    }
    if (ctx && ctx.sit && ctx.src !== 'quiz' && SITS.indexOf(ctx.sit) !== -1) {
      state.preset = ctx.sit;
      state.answers.situation = ctx.sit;
    }
    state.qid = newId();
    var first = route(state.answers)[0];
    state.trail = [first];
    save();
    try { history.replaceState({ r3q: 1 }, ''); } catch (e) {}
    show(first, 'forward', { instant: true, noFocus: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
